export default {
    LIST_GTD: {
        linkTables: [
            "DECLARATION.UNIT",
            "OPERATION.UNIT",
            "PUBLIC.ORDER",
            "COMMENTS",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "INVOICE",
            "INVOICE_POSITIONS",
            "LIST_FEACC_GTD"
        ]
    },
    OPERATION_UNIT_STATUS: {
        linkTables: [
            "OPERATION_UNIT_LINK",
            "OPERATION_UNIT",
            "OPERATION_ARRIVAL_POINT",
            "OPERATION",
            "ORDER",
            "LIST_WAREHOUSES_ROLES_LINK"
        ]
    },
    INVOICE_POSITIONS: {
        cache: false,
        linkTables: [
            "INVOICE_POSITIONS",
            "INVOICE",
            "DECLARATION.UNIT",
            "DECLARATION.DEC_UNIT_OPER_LINK",
            "LIST_FEACC_DOCUMENTS",
            "LIST_FEACC_GTD"
        ]
    },
    INVOICE_INCOMING: {
        linkTables: [
            "INVOICE_POSITIONS",
            "OPERATION.FIN_OPERATION",
            "ICB_OFFICE",
            "CAPITAL_TRANSFER"
        ]
    },
    INVOICE_OUTGOING: {
        linkTables: [
            "INVOICE_POSITIONS",
            "OPERATION.FIN_OPERATION",
            "ORDER_NOTIFICATIONS",
            "OPERATION_ARRIVAL_POINT",
            "ICB_OFFICE",
            "PAYABLE_CSO",
            "LIST_CONTRACTS",
            "CONTRACTS_ADDITION",
            "CAPITAL_TRANSFER"
        ]
    },
    INVOICE_OUTGOING_MONEY: {
        linkTables: [
            "MANAGER_BONUS"
        ]
    },
    LIST_TYPE_ROLE_COMPANY: {
        plugins: [
            {
                name: "StupidFixCompanyRoles"
            }
        ]
    },
    LIST_WAREHOUSES_ROLES_LINK: {
        plugins: [
            {
                name: "StupidFixWarehouseRoles"
            }
        ]
    },
    OPERATION_ARRIVAL_POINT: {
        cache: false
    },
    OPERATION_UINT_INVOICES: {
        linkTables: ["INVOICE_POSITIONS", "INVOICE", "LIST_PAYMENTS_GTD_LINK"]
    },
    INVOICE: {
        linkTables: [
            "INVOICE_POSITIONS",
            "PAYMENT_ORDERS_INVOICES",
            "DECLARATION.UNIT",
            "DECLARATION.DEC_UNIT_OPER_LINK",
            "LIST_FEACC_DOCUMENTS",
            "LIST_FEACC_GTD",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "USER_TASK",
            "LIST_GTD",
            "PUBLIC.ORDER",
            "OPERATION.UNIT",
            "LIST_COMPANY",
            "OPERATION.RATE_EXPENSE_CATEGORY",
            "CAPITAL_OPERATION",
            "CAPITAL_TRANSFER"
        ]
    },
    OPERATION_UNIT: {
        linkTables: [
            "OPERATION_ARRIVAL_POINT",
            "ORDER",
            "LIST_GTD",
            "DECLARATION.UNIT",
            "OPERATION.DOC_OPERATION",
            "OPERATION.DOC_OPERATION_UNIT_LINK",
            "OPERATION.DOC_OPERATION_TYPE",
            "OPERATION.OPERATION",
            "OPERATION_UNIT_LINK",
            "CUSTOM_LOGISTAS.UNIT",
            "OPERATION.OWNER_UNIT",
            "OPERATION.OWN_ROLLING_STOCK_UNIT",
            "OPERATION.FIN_OPERATION_GROUP_UNIT",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "USER_TASK",
            "OPERATION_SUB_DOC",
            "TRAIN",
            "OPERATION.RATE_EXPENSE",
            "LIST_ALL_GTD",
            "LIST_FEACC_GTD",
            "OPERATION.RATE_EXPENSE",
            "LIST_CONTRACTS",
            "OPERATION.FIN_OPERATION"
        ]
    },
    DOC_OPERATION: {
        linkTables: ["OPERATION.DOC_OPERATION_UNIT_LINK"]
    },
    DOC_OPERATION_UNIT_LINK: {
        linkTables: ["OPERATION.DOC_OPERATION", "OPERATION.UNIT", "USER_TASK"],
        plugins: [
            {
                name: "StupidFixDocsLinkNextDate"
            }
        ]
    },
    OPERATION_UNIT_SCOPE: {
        cache: false
    },
    "OPERATION.OPERATION": {
        linkTables: [
            "ORDER",
            "OPERATION_UNIT_LINK",
            "OPERATION.UNIT",
            "OPERATION.OPERATION",
            "OPERATION_ARRIVAL_POINT",
            "CUSTOM_LOGISTAS.UNIT",
            "OPERATION_CUSTOM_STATUS"
        ]
    },
    "PUBLIC.ORDER": {
        linkTables: [
            "OPERATION.UNIT",
            "OPERATION.OPERATION",
            "CUSTOM_LOGISTAS.UNIT",
            "OPERATION_SUB_DOC",
            "LIST_GTD",
            "LIST_ORDER_POSITIONS",
            "DEC_UNIT_OPER_UNIT_LINK",
            "INVOICE",
            "INVOICE_POSITIONS",
            "OPERATION.FIN_OPERATION",
            "COMPANY_CRM_ORDER_LINK",
            "COMPANY_CRM",
            "ORDER_REQUEST",
            "LIST_FEACC_GTD",
            "PAYMENT_ORDERS",
            "PAYMENT_ORDERS_INVOICES"
        ]
    },
    ORDER_REQUEST: {
        linkTables: ["ORDER_REQUEST", "ORDER_DOCS_SCHEME"]
    },
    "CUSTOM_LOGISTAS.UNIT": {
        linkTables: ["OPERATION.UNIT", "OPERATION.OPERATION", "OPERATION.UNIT"]
    },
    FIN_OPERATION_GROUP_UNIT: {
        linkTables: ["FIN_OPERATION_GROUP_UNIT"]
    },
    FIN_OPERATION_DETAIL: {
        linkTables: ["FIN_OPERATION_DETAIL"]
    },
    "OPERATION.FIN_OPERATION": {
        linkTables: [
            "OPERATION.FIN_OPERATION",
            "OPERATION.OPERATION",
            "OPERATION.ARRIVAL_POINT",
            "LIST_PAYMENTS_GTD_LINK",
            "OPERATION.UNIT",
            "INVOICE_POSITIONS",
            "OPERATION_UNIT_LINK",
            "FIN_OPERATION_UNIT_LINK",
            "INVOICE",
            "LIST_CONTRACTS",
            "LIST_CURRENCY",
            "LIST_TYPE_CONTRACTS",
            "LIST_TYPE_VAT",
            "LIST_ORDER_POSITIONS",
            "OPERATION.PACKING_UNIT_TYPE",
            "OPERATION.RATE_EXPENSE_TYPE",
            "OPERATION.UNIT_TYPE",
            "INVOICE_INCOMING",
            "INVOICE_OUTGOING",
            "BATCH_FIN_OPERATION"
        ],
        plugins: [
            {
                name: "StupidFixFinDeleted"
            }
        ]
    },
    COMPANY_COMPANY_LINK: {
        plugins: [
            {
                name: "StupidFixLinkedCompany"
            }
        ]
    },
    LIST_USER: {
        linkTables: [
            "DEPARTMENT_USER_LINK",
            "SYS_ACL_ROLE_USER",
            "SYS_ACL_ROLE",
            "ORDER"
        ]
    },
    DEPARTMENT: {
        linkTables: ["DEPARTMENT_USER_LINK"]
    },
    "DECLARATION.UNIT": {
        linkTables: ["ORDER", "DEC_UNIT_OPER_UNIT_LINK"]
    },
    LIST_COMPANY: {
        linkTables: [
            "COMPANY_USER_LINK",
            "COMPANY_CRM_EVENT",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "USER_TASK",
            "LIST_TYPE_ROLE_COMPANY",
            "COMPANY_CONTACT_PERSONS_LINK",
            "LIST_CONTACT_PERSONS",
            "COMPANY_CRITERIA_VALUE",
            "CRITERIA_TYPE",
            "CRITERIA_VALUE",
            "COMPANY_CRM",
            "INVOICE_OUTGOING",
            "ORDER",
            "LIST_USER"
        ]
    },
    PAYMENT_ORDERS_INVOICES: {
        linkTables: ["INVOICE_POSITIONS"]
    },
    FIN_OPERATION_UNIT_LINK: {
        linkTables: ["OPERATION_UNIT_LINK"]
    },
    CONTRACTS_FEA: {
        linkTables: [
            "CONTRACTS_FEA_ADDITION",
            "CONTRACTS_FEA_ADDITION",
            "LIST_FEACC_DOCUMENTS",
            "LIST_GTD",
            "PAYMENT_ORDERS"
        ]
    },
    "OPERATION.UNIT": {
        linkTables: [
            "OPERATION.UNIT",
            "LIST_COMPANY",
            "OPERATION.ARRIVAL_POINT",
            "OPERATION.RATE_EXPENSE",
            "OPERATION.OPERATION",
            "SEA_LINE_DAYS",
            "LIST_WAREHOUSE",
            "OPERATION.OPERATION_TYPE",
            "LIST_ORDER_POSITIONS",
            "PART_NUMBER",
            "OPERATION_UNIT_LINK"
        ]
    },
    USER_TASK: {
        linkTables: [
            "OPERATION.DOC_OPERATION_UNIT_LINK",
            "USER_TASK_WATCHER_LINK",
            "USER_TASK",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "ORDER"
        ]
    },
    COMMENTS: {
        linkTables: ["USER_TASK", "OPERATION.UNIT", "OPERATION.OPERATION"]
    },
    ORDER: {
        linkTables: [
            "OPERATION.OPERATION",
            "OPERATION.ARRIVAL_POINT",
            "PART_NUMBER_ORDER_LINK",
            "PART_NUMBER",
            "DECLARATION.UNIT",
            "DECLARATION.DEC_UNIT_OPER_UNIT_LINK",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "USER_TASK",
            "COMPANY_CRM_ORDER_LINK",
            "COMPANY_CRM",
            "OPERATION_UNIT",
            "ORDER_ASSISTANT_LINK",
            "LIST_FEACC_GTD",
            "LIST_GTD",
            "LIST_COMPANY",
            "LIST_USER"
        ]
    },
    LIST_CONTRACTS: {
        linkTables: [
            "LIST_DOCUMENTS",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "USER_TASK",
            "LIST_CONTRACTS_BY_COMPANY"
        ]
    },
    LIST_CONTRACTS_BY_COMPANY: {
        linkTables: ["LIST_CONTRACTS"]
    },
    CONTRACTS_ADDITION: {
        linkTables: [
            "LIST_DOCUMENTS",
            "BUSINESS_OPERATION",
            "BUSINESS_PROCESS",
            "USER_TASK"
        ]
    },
    PART_NUMBER_POSITION: {
        linkTables: ["PART_NUMBER"],
        plugins: [
            {
                name: "StupidFixReloadPartNumberPositionErrorsOnDuplicate"
            }
        ]
    },
    LIST_WAREHOUSE: {
        linkTables: ["LIST_WAREHOUSES_ROLES_LINK"]
    },
    PART_NUMBER: {
        linkTables: ["PART_NUMBER_ORDER_LINK", "PART_NUMBER_POSITION"]
    },
    LIST_ORDER_POSITIONS: {
        linkTables: [
            "LIST_ORDER_POSITIONS",
            "OPERATION.ARRIVAL_POINT",
            "OPERATION.RATE_EXPENSE",
            "OPERATION.OPERATION",
            "SEA_LINE_DAYS",
            "LIST_WAREHOUSE"
        ]
    },
    COMPANY_CRM: {
        linkTables: ["COMPANY_USER_LINK", "ORDER", "COMPANY_CRM_ORDER_LINK"]
    },
    ORDER_FOR_OWNER_UNIT: {
        linkTables: [
            "OPERATION.OPERATION",
            "OPERATION.FIN_OPERATION",
            "OPERATION.ARRIVAL_POINT"
        ]
    },
    ORDER_FOR_OWN_ROLLING_STOCK_UNIT: {
        linkTables: [
            "OPERATION.OPERATION",
            "OPERATION.FIN_OPERATION",
            "OPERATION.ARRIVAL_POINT"
        ]
    },
    OWNER_UNIT: {
        linkTables: [
            "OPERATION.UNIT",
            "OPERATION.FIN_OPERATION",
            "OPERATION.OPERATION",
            "OPERATION.ARRIVAL_POINT",
            "PUBLIC.ORDER",
            "OPERATION_UNIT_LINK",
            "LIST_WAREHOUSE"
        ]
    },
    OWN_ROLLING_STOCK_UNIT: {
        linkTables: [
            "OPERATION.UNIT",
            "OPERATION.FIN_OPERATION",
            "OPERATION.OPERATION",
            "OPERATION.ARRIVAL_POINT",
            "PUBLIC.ORDER",
            "OPERATION_UNIT_LINK",
            "LIST_WAREHOUSE"
        ]
    },
    TP_ELS: {
        linkTables: [
            "OPERATION.UNIT",
            "PUBLIC.ORDER",
            "LIST_WAREHOUSE",
            "COMPANY_GTD_BALANCE",
            "PAYMENT_ORDERS",
            "LIST_USER",
            "LIST_COMPANY"
        ]
    },
    PAYMENT_ORDERS: {
        linkTables: [
            "LIST_COMPANY_BANK_ACCOUNTS",
            "PAYMENT_ORDERS_INVOICES",
            "PAYMENT_ORDERS_TRANSFERS",
            "PAYMENT_ORDERS_INCOMING",
            "PAYMENT_ORDERS_OUTGOING",
            "CAPITAL_OPERATION",
            "CAPITAL_TRANSFER"
        ]
    },
    PAYMENT_ORDERS_INCOMING: {
        linkTables: ["PAYMENT_ORDERS"]
    },
    PAYMENT_ORDERS_OUTGOING: {
        linkTables: [
            "PAYMENT_ORDERS",
            "MANAGER_BONUS"
        ]
    },
    COMPANY_GTD_BALANCE: {
        linkTables: ["PAYMENT_ORDERS"]
    },
    LIST_CLASSIFICATION: {
        linkTables: ["CLASS_ACCESS_DOCS_LINK"]
    },
    CLASS_ACCESS_DOCS: {
        linkTables: [
            "CLASS_ACCESS_DOCS_LINK",
            "LIST_CLASSIFICATION",
            "LIST_DOCUMENTS"
        ]
    },
    LIST_FEACC_GTD: {
        linkTables: ["LIST_FEACC_DOCUMENTS"]
    },
    USER_TASK_THEME: {
        linkTables: ["USER_TASK_THEME_WATCHER_LINK"]
    },
    USER_TASK_THEME_TO_BUS_OP: {
        linkTables: ["BUSINESS_PROCESS"]
    },
    USER_TASK_WATCHER_LINK: {
        cache: false
    },
    BUSINESS_PROCESS: {
        linkTables: ["BUSINESS_OPERATION", "USER_TASK"]
    },
    TEMPLATE_INVOICE: {
        linkTables: [
            "LIST_COMPANY",
            "TEMPLATE_INVOICE_POSITION",
            "TEMPLATE_INVOICE_COMPANY_CONSIGNEE_LINK",
            "TEMPLATE_INVOICE_COMPANY_CONSIGNOR_LINK"
        ]
    },
    TEMPLATE_INVOICE_POST: {
        linkTables: [
            "TEMPLATE_INVOICE",
            "LIST_COMPANY",
            "TEMPLATE_INVOICE_COMPANY_CONSIGNEE_LINK",
            "TEMPLATE_INVOICE_COMPANY_CONSIGNOR_LINK"
        ]
    },
    DOCS_EMAIL_BROADCAST_QUEUE: {
        cache: false,
        linkTables: ["LIST_DOCUMENTS"]
    },
    "CAPITAL.TRANSFER": {
        plugins: [
            {
                name: "RemoveInsteadOfTrash"
            }
        ],
        linkTables: [
            "CAPITAL.ACCOUNT",
            "CAPITAL.CONVERSION_OPERATION",
            "INVOICE",
            "PAYMENT_ORDERS"
        ]
    },
    CAPITAL_TRANSFER: {
        plugins: [
            {
                name: "RemoveInsteadOfTrash"
            }
        ]
    },
    CAPITAL_ACCOUNT: {
        plugins: [
            {
                name: "RemoveInsteadOfTrash"
            }
        ]
    },
    CAPITAL_CONVERSION_OPERATION: {
        plugins: [
            {
                name: "RemoveInsteadOfTrash"
            }
        ]
    },
    "CAPITAL.ACCOUNT": {
        linkTables: [
            "CAPITAL.TRANSFER",
            "CAPITAL_TRANSFER",
            "CAPITAL.OPERATION",
            "CAPITAL_OPERATION",
            "CAPITAL.CONVERSION_OPERATION"
        ]
    },
    OPERATION_SUB_DOC: {
        linkTables: ["OPERATION_UNIT", "LIST_GTD"]
    },
    LIST_CONTACT_PERSONS: {
        linkTables: ["COMPANY_CONTACT_PERSONS_LINK"]
    },
    CHECK_CUSTOM_PAYMENTS: {
        linkTables: ["INVOICE_POSITIONS", "INVOICE"]
    },
    TRAIN: {
        linkTables: ["OPERATION.UNIT"]
    },
    ORDER_DOCS_SCHEME: {
        linkTables: ["ORDER_REQUEST"]
    },
    BATCH_FIN_OPERATION: {
        linkTables: ["OPERATION.FIN_OPERATION"]
    },
    LIST_ALL_GTD: {
        linkTables: ["PUBLIC.LIST_GTD", "PUBLIC.ORDER", "OPERATION.UNIT"]
    },
    STORAGE_RATES: {
        linkTables: ["COMPANY_STORAGE_RATES"]
    },
    REPORT_OUR_COMPANYS: {
        linkTables: ["REPORT_SETTINGS"]
    },
    ALTA_CBX_DATA: {
        linkTables: ["LIST_DOCUMENTS"]
    },
    PAYMENT_ORDERS_LIST_GTD_LINK: {
        linkTables: ["PAYMENT_ORDERS_LIST_GTD_LINK"]
    },
    REQUEST_CURRENCY_TRANSLATION: {
        linkTables: ["BUSINESS_OPERATION", "BUSINESS_PROCESS"]
    }
};
